import { useEffect } from 'react';

export const useFavicon = (faviconUrl: string) => {
	useEffect(() => {
		const favicon = document.getElementById("favicon");
		if (faviconUrl) {
			favicon.setAttribute("href", faviconUrl);
		} else {
			favicon.setAttribute("href", "/axnui/favicon.ico");
		}
	}, [faviconUrl]);
};